import { SharedAngular } from '@Client/@types/sharedAngular';
import { ProcedureViewMode } from '@Shared.Angular/@types/core/contracts/constants/procedureViewMode';
import angular from 'angular';
import { IStateParamsService, IStateProvider } from 'angular-ui-router';
import { STATE_MAPPINGS } from '@Shared.Angular/@types/stateMappings';

angular.module('flowingly.runner.procedures').config(config);

config.$inject = ['$stateProvider'];

function config($stateProvider: IStateProvider) {
  $stateProvider.state(STATE_MAPPINGS.procedure, {
    url: 'sops/:procedureId?viewMode&aiEnhance&schemaId',
    params: {
      title: 'SOP'
    },
    controller: 'procedureController',
    controllerAs: '$ctrl',
    templateUrl: 'Client/runner.procedures/runner.procedure.tmpl.html',
    resolve: {
      procedure: [
        'procedureApiService',
        '$stateParams',
        function (
          procedureApiService: SharedAngular.ProcedureApiService,
          $stateParams: IStateParamsService
        ) {
          const viewMode =
            $stateParams.viewMode === undefined ||
            $stateParams.viewMode === null
              ? ProcedureViewMode.ReadOnly
              : Number($stateParams.viewMode);
          $stateParams.viewMode = viewMode;
          const recordView =
            viewMode === ProcedureViewMode.ReadOnly && !$stateParams.schemaId;
          return procedureApiService.getProcedure(
            $stateParams.procedureId,
            viewMode,
            recordView,
            $stateParams?.schemaId
          );
        }
      ]
    }
  });
}
